/* eslint-disable react/display-name */
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@chakra-ui/react';

import messages from './messages';
import { formatCurrency } from 'src/utils/i18n';

const renderSKURow = row => row.sku?.split('|')?.[0] || '-';

const getSKUColumn = intl => ({
  name: intl.formatMessage(messages.skuTableHeader),
  cell: renderSKURow,
});

const renderProductName = row => {
  const variantPathname = `/product/${row.product_id}/variant/${row.id}`;

  return (
    <Link as={RouterLink} to={variantPathname} isExternal>
      {row.title}
    </Link>
  );
};

const getProductNameColumn = intl => ({
  name: intl.formatMessage(messages.nameTableHeader),
  cell: renderProductName,
});

const renderOptionRow = index => row => row[`option${index + 1}`];

const getProductOptionsColumns = options =>
  options?.map((option, index) => ({
    name: option.name,
    cell: renderOptionRow(index),
  })) ?? [];

const renderPriceRow = (intl, fullPrice) => row =>
  row.price && fullPrice ? formatCurrency(intl, fullPrice) : '-';

const getPriceColumn = (intl, { fullPrice }) => ({
  name: intl.formatMessage(messages.priceTableHeader),
  cell: renderPriceRow(intl, fullPrice),
  options: {
    isNumeric: true,
  },
});

export const getTableColumns = (intl, { fullPrice, options }) => [
  getSKUColumn(intl),
  getProductNameColumn(intl),
  ...getProductOptionsColumns(options),
  getPriceColumn(intl, { fullPrice }),
];
